import React,{ useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';


import './AutoScrolling.less'

const AutoScrolling = () =>{
  const navigate = useNavigate();


  return (
    <div className="scrolling-text-box">
      <span className="scrolling-text">
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
        <span className="text-item">“I can tell a huge difference”·MEGAN A</span>
      </span>
    </div>
  )
}

export default AutoScrolling